import SalesOrderLineInterface from '@/interfaces/SalesOrderLineInterface';
import LinesUtility from '@/utility/lines-utility';

interface ProgressContainerProps {
  lines: Array<SalesOrderLineInterface>;
}

const getPersonalisedProductsCount = (lines: Array<SalesOrderLineInterface>) => {
  const groups = new Map();

  lines.forEach((item) => {
    const key = `${item.External_Document_Line_No}`;

    if (!groups.has(key)) {
      groups.set(key, []);
    }

    groups.get(key).push(item);
  });

  return [...groups.values()].filter((group) => group.every((item: SalesOrderLineInterface) => item.Line_Notes?.trim()))
    .length;
};

export const ProgressContainer = ({ lines = [] }: ProgressContainerProps) => {
  const totalProductsCount = LinesUtility.totalProducts(lines);

  const productsPersonalisedCount = getPersonalisedProductsCount(lines);

  const personalisedPiecesCount = lines
    .filter((line) => LinesUtility.isPersonalised(line))
    .reduce((sum, line) => sum + LinesUtility.quantity(line), 0);

  const totalPiecesCount = lines.reduce((sum, line) => sum + LinesUtility.quantity(line), 0);

  const progressPercentage = totalPiecesCount === 0 ? 0 : (personalisedPiecesCount / totalPiecesCount) * 100;

  return (
    <section
      aria-label="Overall personalisation progress"
      className="w-full border border-[#d1d1d1] bg-white px-[18px] py-[16px] sm:max-w-[390px] sm:px-[22px] sm:py-[19px]"
    >
      {/* <h2 id="overall-progress-heading" className="text-[12px] font-semibold leading-[16px]">
        Overall progress
      </h2> */}

      <p className="mt-[5px] text-[clamp(24px,calc(22px_+_0.3vw),25px)] leading-[29px] font-medium">
        <span className="font-extrabold">{productsPersonalisedCount}</span>{' '}
        <span className="">of {totalProductsCount} products completed</span>
      </p>

      <div
        aria-label={`${personalisedPiecesCount} of ${totalPiecesCount} pieces personalised`}
        aria-valuemax={totalPiecesCount}
        aria-valuemin={0}
        aria-valuenow={personalisedPiecesCount}
        className="mt-[13px] h-[8px] overflow-hidden rounded-full bg-slate-200"
        role="progressbar"
      >
        <div
          className="h-full rounded-full bg-green-600 transition-[width] duration-500 ease-out"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>

      <p className="mt-[8px] text-[14px] font-light leading-[16px] text-slate-600 font-[Arial]">
        {personalisedPiecesCount} of {totalPiecesCount} pieces personalised
      </p>
    </section>
  );
};

export default ProgressContainer;
